import { useParams } from 'react-router'

export function useCategorySlug () {
  const params = useParams()
  return params.categorySlug
}